const duration = 0.7
const ease = 'power2.inOut'

class FsFacets extends HTMLElement {
  constructor() {
    super()

    this.elFilterButton = this.querySelector('.js-filter-button')
    this.elFilterContainer = this.querySelector('.js-filter-container')
    this.elFilterContainerInner = this.elFilterContainer.querySelector('.facets__filter__container__inner')
    this.elsFilters = this.elFilterContainerInner.children

    this.elSortButton = this.querySelector('.js-sort-button')
    this.elSortContainer = this.querySelector('.js-sort-container')
    this.elsSortOptions = this.elSortContainer.querySelectorAll('.facets__filter__list li')

    this.isFilterOpen = false
    this.isSortOpen = false

    this.addEventListeners()
  }

  addEventListeners() {
    this.elFilterButton.addEventListener('click', () => this.onClickFilterButton())
    this.elSortButton.addEventListener('click', () => this.onClickSortButton())
  }

  async onClickFilterButton() {
    this.isFilterOpen = !this.isFilterOpen

    if (this.isFilterOpen) {
      if (this.isSortOpen) {
        this.isSortOpen = false
        await this.closeSort()
      }
      this.openFilters()
    } else {
      this.closeFilters()
    }
  }

  async onClickSortButton() {
    this.isSortOpen = !this.isSortOpen

    if (this.isSortOpen) {
      if (this.isFilterOpen) {
        this.isFilterOpen = false
        await this.closeFilters()
      }
      this.openSort()
    } else {
      this.closeSort()
    }
  }

  openFilters() {
    this.elFilterButton.classList.toggle('active', this.isFilterOpen)
    this.elFilterContainer.classList.toggle('active', this.isFilterOpen)

    const height = this.elFilterContainer.scrollHeight
    return gsap.timeline().fromTo(this.elFilterContainer,
      { height: 0, },
      { height, duration, ease }
    ).fromTo(this.elsFilters,
      { opacity: 0, },
      { opacity: 1, duration, ease, stagger: 0.05 },
      0.2
    ).set(this.elFilterContainer, { clearProps: 'all' })
  }

  closeFilters() {
    this.elFilterButton.classList.toggle('active', this.isFilterOpen)

    const onComplete = () => {
      this.elFilterContainer.classList.toggle('active', this.isFilterOpen)
    }

    return gsap.timeline({ onComplete })
      .to(this.elsFilters, { opacity: 0, duration: 0.2, ease: 'none' })
      .to(this.elFilterContainer, { height: 0, duration, ease }, '<')
  }

  openSort() {
    this.elSortButton.classList.toggle('active', this.isSortOpen)
    this.elSortContainer.classList.toggle('active', this.isSortOpen)

    const height = this.elSortContainer.scrollHeight
    return gsap.timeline().fromTo(this.elSortContainer,
      { height: 0, },
      { height, duration, ease }
    ).fromTo(this.elsSortOptions,
      { opacity: 0, },
      { opacity: 1, duration, ease },
      0.2
    ).set(this.elSortContainer, { clearProps: 'all' })
  }

  closeSort() {
    this.elSortButton.classList.toggle('active', this.isSortOpen)

    const onComplete = () => {
      this.elSortContainer.classList.toggle('active', this.isSortOpen)
    }

    return gsap.timeline({ onComplete })
      .to(this.elsSortOptions, { opacity: 0, duration: 0.2, ease: 'none' })
      .to(this.elSortContainer, { height: 0, duration, ease }, '<')
  }
}

if (!customElements.get('fs-facets')) {
  customElements.define('fs-facets', FsFacets)
}
